<template>
  <b-row
    :class="[
      'py-1',
      $style.wrapper,
      isMyPosition && $style.isMyPosition
    ]"
  >
    <b-col
      :cols="6"
      :md="8"
      :lg="9"
      class="d-flex align-items-center"
    >
      <BaseTextH1
        :class="[
          $style.positionWrapper
        ]"
      >
        {{ position }}
      </BaseTextH1>
      <BaseAvatar
        :size="75"
        :url="avatar"
        is-lazy
      />
      <div class="px-2">
        <span :class="$style.nameWrapper">
          <template v-if="isMyPosition">{{ $t('you') }}</template>
          <template v-else>{{ name }}</template>
        </span>
        <span :class="$style.scoreTextWrapper">{{ $t('score') }}:&nbsp;</span>
        <span :class="$style.scoreWrapper">{{ score }}</span>
      </div>
    </b-col>
    <b-col
      :cols="6"
      :md="4"
      :lg="3"
      class="d-flex flex-column justify-content-center align-items-center"
    >
      <template v-if="predictions">
        <div
          v-for="tmp in predictions.scores"
          :key="`score-row-${tmp.id}`"
          class="d-flex justify-content-center"
        >
          <BaseAvatar
            :url="tmp.match.team1.image_url"
            :size="35"
            is-lazy
          />
          <div class="d-flex flex-column justify-content-center align-items-center text-center px-2">
            <span :class="$style.scoreWrapper">{{ tmp.score_team1 }} - {{ tmp.score_team2 }}</span>
          </div>
          <BaseAvatar
            :url="tmp.match.team2.image_url"
            :size="35"
            is-lazy
          />
        </div>
        <div
          v-for="athlete in predictions.athletes"
          :key="`score-row-${athlete.id}`"
          class="d-flex align-items-center justify-content-center pt-2"
        >
          <BaseAvatar
            :size="30"
            :url="athlete.image_url"
            is-lazy
          />
          <div
            :class="[
              'px-2',
              $style.pickedAthleteName
            ]"
          >
            {{ athlete.first_name[$i18n.locale] }}
            {{ athlete.last_name[$i18n.locale] }}
          </div>
        </div>
      </template>
      <template v-else>
        {{ $t('no-prediction') }}
      </template>
    </b-col>
  </b-row>
</template>

<script>
import BaseTextH1 from '@/components/Atoms/Typography/BaseTextH1'
import BaseAvatar from '@/components/Atoms/BaseAvatar'
export default {
  name: 'ThePoolUserRow',
  components: { BaseAvatar, BaseTextH1 },
  props: {
    name: {
      type: String,
      required: true,
    },
    avatar: {
      type: String,
      required: true,
    },
    score: {
      type: Number,
      required: true,
    },
    position: {
      type: Number,
      required: true,
    },
    predictions: {
      type: [Object, Boolean],
      required: true,
    },
    isMyPosition: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
}
</script>

<style module lang="scss">
  @import "../../../../assets/scss/variables";
  .wrapper {
    transition: all .3s ease-in-out;
    border-bottom: 2px solid $color-bleached-silk;
    &.isMyPosition {
      background: lighten($color-alley, 15);
      &:hover {
        background: lighten($color-alley, 9);
      }
    }
    .positionWrapper {
      width: 45px;
      text-align: center;
    }
    .nameWrapper {
      display: block;
      font-weight: 600;
    }
    .scoreWrapper {
      color: $color-tomato;
      font-weight: 600;
    }
    .pickedAthleteName {
      font-size: $font-size-small;
      text-align: center;
    }
  }
</style>
